import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  cta,
}: {
  title: string;
  description?: string;
  cta?: ReactNode;
}) {
  return (
    <div className="border border-dashed rounded-lg p-12 text-center">
      <h3 className="font-medium">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
